'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { setToString } from '../../../core/utilities/set.utils.js';
import { removeCoreProps } from '../core/core.utils.js';
import { ProgressBarContainer } from './progress-bar-container.component.js';
import { ProgressOutput } from './progress-output.component.js';
import { Progress } from './progress.component.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';
import { renderWithRef } from '../core/render-with-ref.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const ProgressBar = renderWithRef('ProgressBar', void 0, (c, a)=>{
    let l = setToString(processStyleProps(c, c.className ? [
        c.className
    ] : void 0)), u = _object_spread_props(_object_spread({}, removeCoreProps(c)), {
        as: c.as,
        component: c.component,
        render: c.render
    });
    return jsxs(ProgressBarContainer, {
        className: l,
        children: [
            jsx(Progress, _object_spread_props(_object_spread({
                ref: a
            }, u), {
                children: c.children
            })),
            null === c.value || void 0 === c.value ? null : jsxs(ProgressOutput, {
                children: [
                    c.value,
                    "%"
                ]
            })
        ]
    });
});

export { ProgressBar };
